// src/contexts/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UserPool from '../components/userPool';
import secureLocalStorage from 'react-secure-storage';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Load current session from Cognito
  const loadSession = () => {
    const currentUser = UserPool.getCurrentUser();

    if (!currentUser) {
      setUser(null);
      setToken(null);
      setLoading(false);
      return;
    }

    currentUser.getSession((err, session) => {
      if (err || !session.isValid()) {
        setUser(null);
        setToken(null);
      } else {
        setUser(currentUser);
        setToken(session.getIdToken().getJwtToken());
        secureLocalStorage.setItem('awsSignInToken', session.getIdToken().getJwtToken());
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    loadSession();
  }, []);

  // Refresh + return a valid token
  const getValidToken = () =>
    new Promise((resolve, reject) => {
        const currentUser = UserPool.getCurrentUser();
        if (!currentUser) return reject("No user logged in");

        currentUser.getSession((err, session) => {
          if (err || !session.isValid()) {
            logout();
          } else {
            const jwt = session.getIdToken().getJwtToken();
            setToken(jwt);
            secureLocalStorage.setItem('awsSignInToken', jwt);
            resolve(jwt);
          }
      });
    });

  const login = (cognitoUser, jwtToken) => {
    setUser(cognitoUser);
    setToken(jwtToken);
    secureLocalStorage.setItem('awsSignInToken', jwtToken);
  };

  const logout = () => {
    const currentUser = UserPool.getCurrentUser();
    if (currentUser) currentUser.signOut();

    setUser(null);
    setToken(null);
    secureLocalStorage.removeItem('awsSignInToken');
    localStorage.removeItem('user');
    localStorage.removeItem('isActiveSubscriber');
    localStorage.removeItem('subscriberMetadata');
    localStorage.removeItem('trialleft');
    localStorage.removeItem('jsonOutput');
    localStorage.removeItem('HashedID');

    const cognitoDomain = "https://loggable.auth.us-east-1.amazoncognito.com";
    const clientId = '5vbhldlu8uhcvba8rvvngogjpv';
    const logoutUrl = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${window.location.origin}/login`;

    window.location.href = logoutUrl;
  };

  return (
    <AuthContext.Provider 
      value={{ user, token, login, logout, loading, reloadSession: loadSession, getValidToken }}
    >
      {loading ? <div>Loading...</div> : children}
    </AuthContext.Provider>
  );
};
